<div class="filemanager-dialog">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">Attachment Manager</span>
      <div class="actions" fxLayout="row" fxLayoutAlign="start center" style="cursor: default">
        <div style="display: contents" (mousedown)="$event.stopPropagation()">
          <button mat-icon-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon class="fg-icon">close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <dx-load-panel [position]="{ of: '#file-manager' }"></dx-load-panel>
  <dx-load-panel [position]="{ of: '#file-manager' }"></dx-load-panel>
  <dx-file-manager
    #fileManager
    id="file-manager"
    [fileSystemProvider]="fileSystemProvider"
    [allowedFileExtensions]="allowedFileExtensions"
    [customizeDetailColumns]="customizeColumns"
    (onContextMenuItemClick)="onContextMenuItemClick($event)"
    (onToolbarItemClick)="onToolbarItemClick($event)"
    (onErrorOccurred)="onErrorOccurred($event)"
    (onSelectionChanged)="onSelectionChanged($event)"
    (onContextMenuShowing)="onContextMenuShowing($event)"
    (onContentReady)="onContentReady($event)"
    (onItemCopied)="refresh()"
    (onItemDeleted)="refresh()"
    (onItemMoved)="refresh()"
    (onItemRenamed)="refresh()"
    (onFileUploaded)="refresh()"
    (dblclick)="openFiles()"
  >
    <dxo-permissions
      [create]="true"
      [copy]="true"
      [move]="true"
      [delete]="true"
      [download]="true"
      [rename]="true"
      [upload]="true"
    >
    </dxo-permissions>

    <dxo-item-view [showParentFolder]="false">
      <dxo-details>
        <dxi-column dataField="thumbnail" alignment="left"></dxi-column>
        <dxi-column dataField="name" alignment="left"></dxi-column>
        <dxi-column dataField="exportStatusIcon" caption="" alignment="left"></dxi-column>
        <dxi-column dataField="dataItem.summary" caption="Summary" alignment="left"></dxi-column>
        <dxi-column dataField="dataItem.labels" caption="Labels" alignment="left"></dxi-column>
        <dxi-column dataField="dateModified" dataType="date" caption="Date Uploaded" alignment="left"></dxi-column>
        <dxi-column dataField="size" alignment="left"></dxi-column>
      </dxo-details>
    </dxo-item-view>

    <dxo-toolbar>
      <dxi-item name="create"></dxi-item>
      <dxi-item
        name="Upload Files"
        widget="dxButton"
        [options]="{ text: 'Upload Files', onClick: uploadFiles, icon: 'upload' }"
      >
      </dxi-item>
      <dxi-item
        name="Upload Folder"
        widget="dxButton"
        [options]="{ text: 'Upload Folder', onClick: uploadFolder, icon: 'parentfolder' }"
      >
      </dxi-item>
      <dxi-item name="switchView"></dxi-item>
      <dxi-item name="separator" location="after"></dxi-item>
      <dxi-item name="refresh"></dxi-item>

      <dxi-file-selection-item name="download" text="Open" icon="file" [options]="{ onClick: openFiles }">
      </dxi-file-selection-item>
      <dxi-file-selection-item name="download" [options]="{ onClick: downloadFiles }"> </dxi-file-selection-item>
      <dxi-file-selection-item name="separator"></dxi-file-selection-item>
      <dxi-file-selection-item
        *ngIf="showCasePrepUI"
        name="exportToCasePreparationFile"
        widget="dxButton"
        [options]="{
          text: 'Export to Case Preparation File',
          onClick: exportToCasePreparationFile,
          icon: 'exportselected'
        }"
      >
      </dxi-file-selection-item>
      <dxi-file-selection-item name="separator"></dxi-file-selection-item>
      <dxi-file-selection-item name="move" text="Move"></dxi-file-selection-item>
      <dxi-file-selection-item name="copy" text="Copy"></dxi-file-selection-item>
      <dxi-file-selection-item name="rename"></dxi-file-selection-item>
      <dxi-file-selection-item
        *ngIf="selection.length <= 1"
        name="download"
        text="Edit Labels and Summary"
        icon="tags"
        widget="dxButton"
        [options]="{
          onClick: openEditLabels,
        }"
      >
      </dxi-file-selection-item>
      <dxi-file-selection-item name="separator"></dxi-file-selection-item>
      <dxi-file-selection-item name="delete"></dxi-file-selection-item>
      <dxi-file-selection-item name="clearSelection" location="after"></dxi-file-selection-item>
    </dxo-toolbar>

    <dxo-context-menu>
      <dxi-item
        name="download"
        text="Open"
        icon="file"
        [beginGroup]="true"
        [options]="{ onClick: openFiles }"
      ></dxi-item>
      <dxi-item name="download" text="Download" [options]="{ onClick: downloadFiles }"></dxi-item>
      <dxi-item
        *ngIf="showCasePrepUI"
        text="Export to Case Preparation File"
        icon="exportselected"
        [options]="{ onClick: exportToCasePreparationFile }"
      ></dxi-item>
      <dxi-item [beginGroup]="true" name="move" text="Move"></dxi-item>
      <dxi-item name="copy" text="Copy"></dxi-item>
      <dxi-item name="rename"></dxi-item>
      <dxi-item
        name="download"
        text="Edit Labels and Summary"
        icon="tags"
        [options]="{ onClick: openEditLabels }"
      ></dxi-item>
      <dxi-item [beginGroup]="true" name="delete"></dxi-item>
      <dxi-item name="create"></dxi-item>
      <dxi-item name="upload" text="Upload Files" icon="upload" [options]="{ onClick: uploadFiles }"></dxi-item>
      <dxi-item name="upload" text="Upload Folder" icon="parentfolder" [options]="{ onClick: uploadFolder }"></dxi-item>
      <dxi-item [beginGroup]="true" name="refresh"></dxi-item>
    </dxo-context-menu>

    <dxo-upload [chunkSize]="1048576" [maxFileSize]="maxFileUploadSize" ></dxo-upload>    
  </dx-file-manager>
</div>

<dx-popup
  [width]="680"
  [height]="'auto'"
  [showTitle]="true"
  title="Edit Labels and Summary"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="editLabelsVisible"
  (onDisposing)="closeEditLabels()"
>
  <dx-text-box
    [value]="summary"
    placeholder="Summary"
    [showClearButton]="true"
    (onValueChanged)="addSummary($event)"
    class="edit-summary"
  >
  </dx-text-box>
  <mat-form-field class="w-100-p">
    <mat-chip-grid #chipList aria-label="Labels">
      <mat-chip-row *ngFor="let label of labels" [selectable]="true" [removable]="true" (removed)="removeLabel(label)">
        {{ label }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input
        placeholder="Labels"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="'remove'"
        maxlength="20"
        (matChipInputTokenEnd)="addLabel($event)"
      />
    </mat-chip-grid>
  </mat-form-field>

  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after">
    <dx-button
      stylingMode="contained"
      text="Save"
      type="normal"
      [width]="120"
      (onClick)="updateMetadata(); closeEditLabels()"
    >
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after">
    <dx-button stylingMode="contained" text="Close" type="normal" [width]="120" (onClick)="closeEditLabels()">
    </dx-button>
  </dxi-toolbar-item>
</dx-popup>
